// extracted by mini-css-extract-plugin
export default {"button":"PetRecall_button__OGZPO","buttonOutline":"PetRecall_buttonOutline__e4Non","rescueBase":"PetRecall_rescueBase__6w2A2","textDanger":"PetRecall_textDanger__hfPm5"};